"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionClient = exports.GetPositionsResponse = exports.GetPositionsRequest = exports.EmployeeOverviewResponse = exports.EmployeeOverviewCertificationResponse = exports.EmployeeOverviewFlowResponse = exports.CreateOrUpdatePositionRequest = exports.ChangeFlowDesignLinkedToPositionListing = exports.FlowDesignLinkedToPositionListing = exports.SetAccessRequestDefaultPositionRequest = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const dayjs_1 = (0, tslib_1.__importDefault)(require("dayjs"));
const ResponseBase_1 = require("../ResponseBase");
const utils_1 = require("../utils");
const handler_1 = require("../utils/handler");
const models_1 = require("./models");
const FlowStatus_1 = require("../flow/FlowStatus");
const certification_1 = require("../certification");
class SetAccessRequestDefaultPositionRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], SetAccessRequestDefaultPositionRequest.prototype, "positionId", void 0);
exports.SetAccessRequestDefaultPositionRequest = SetAccessRequestDefaultPositionRequest;
class FlowDesignLinkedToPositionListing extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesignLinkedToPositionListing.prototype, "flowDesignId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesignLinkedToPositionListing.prototype, "positionId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesignLinkedToPositionListing.prototype, "flowDesignName", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesignLinkedToPositionListing.prototype, "positionName", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsNumber)(),
    (0, tslib_1.__metadata)("design:type", Number)
], FlowDesignLinkedToPositionListing.prototype, "sortBias", void 0);
exports.FlowDesignLinkedToPositionListing = FlowDesignLinkedToPositionListing;
class ChangeFlowDesignLinkedToPositionListing extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], ChangeFlowDesignLinkedToPositionListing.prototype, "positionId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], ChangeFlowDesignLinkedToPositionListing.prototype, "flowDesignId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsIn)(['ABSENT', 'PRESENT']),
    (0, tslib_1.__metadata)("design:type", String)
], ChangeFlowDesignLinkedToPositionListing.prototype, "state", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, tslib_1.__metadata)("design:type", Number)
], ChangeFlowDesignLinkedToPositionListing.prototype, "sortBias", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], ChangeFlowDesignLinkedToPositionListing.prototype, "performUpdates", void 0);
exports.ChangeFlowDesignLinkedToPositionListing = ChangeFlowDesignLinkedToPositionListing;
class CreateOrUpdatePositionRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.IsNotEmpty)(),
    (0, tslib_1.__metadata)("design:type", String)
], CreateOrUpdatePositionRequest.prototype, "name", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], CreateOrUpdatePositionRequest.prototype, "positionId", void 0);
exports.CreateOrUpdatePositionRequest = CreateOrUpdatePositionRequest;
class EmployeeOverviewFlowResponse extends ResponseBase_1.ResponseBase {
    requiresUserInput() {
        return this.isUserInputRequired;
    }
    requiresBusinessInput() {
        return this.isBusinessInputRequired;
    }
    percentage() {
        if (!this.requiresBusinessInput && !this.requiresUserInput) {
            return utils_1.Percentage.create({
                total: this.tasks.total,
                value: this.tasks.total,
            });
        }
        return this.tasks;
    }
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], EmployeeOverviewFlowResponse.prototype, "isUserInputRequired", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewFlowResponse.prototype, "name", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsUUID)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewFlowResponse.prototype, "flowId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsEnum)(FlowStatus_1.FlowStatus),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewFlowResponse.prototype, "status", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], EmployeeOverviewFlowResponse.prototype, "isBusinessInputRequired", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsInstance)(utils_1.Percentage),
    (0, tslib_1.__metadata)("design:type", utils_1.Percentage)
], EmployeeOverviewFlowResponse.prototype, "tasks", void 0);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewFlowResponse.prototype, "percentage", null);
exports.EmployeeOverviewFlowResponse = EmployeeOverviewFlowResponse;
class EmployeeOverviewCertificationResponse extends ResponseBase_1.ResponseBase {
    requiresUserInput() {
        return (this.hasExpired() ||
            this.isInExpiryNoticePeriod() ||
            [
                certification_1.CertSubmissionStatus.UNSUBMITTED,
                certification_1.CertSubmissionStatus.REJECTED,
            ].includes(this.status));
    }
    requiresBusinessInput() {
        return this.status === certification_1.CertSubmissionStatus.SUBMITTED;
    }
    hasExpired() {
        if (!this.expiresAt) {
            return false;
        }
        return this.expiresAt.hasPassed();
    }
    isInExpiryNoticePeriod() {
        if (!this.expiresAt || !this.expiryNoticePeriodInDays) {
            return false;
        }
        return this.expiresAt.hasPassed((0, dayjs_1.default)().subtract(this.expiryNoticePeriodInDays, 'day').toDate());
    }
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewCertificationResponse.prototype, "name", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsEnum)(certification_1.CertSubmissionStatus),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewCertificationResponse.prototype, "status", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewCertificationResponse.prototype, "certificationDesignId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", Number)
], EmployeeOverviewCertificationResponse.prototype, "expiryNoticePeriodInDays", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, tslib_1.__metadata)("design:type", utils_1.TimeAndDate)
], EmployeeOverviewCertificationResponse.prototype, "expiresAt", void 0);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewCertificationResponse.prototype, "requiresUserInput", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewCertificationResponse.prototype, "requiresBusinessInput", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewCertificationResponse.prototype, "hasExpired", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewCertificationResponse.prototype, "isInExpiryNoticePeriod", null);
exports.EmployeeOverviewCertificationResponse = EmployeeOverviewCertificationResponse;
class EmployeeOverviewResponse extends ResponseBase_1.ResponseBase {
    percentComplete() {
        let percent = utils_1.Percentage.create({ total: 0, value: 0 });
        this.flows.forEach((flow) => (percent = flow.percentage().add(percent)));
        percent = utils_1.Percentage.of(this.certifications, this.certifications.filter((v) => !v.requiresUserInput() && !v.requiresBusinessInput())).add(percent);
        return percent;
    }
    businessTagline() {
        const flows = this.flowsRequiringBusinessInput();
        const certs = this.certificationsRequiringBusinessInput();
        return this.formatTagline(flows, certs);
    }
    userTagline() {
        const flows = this.flowsRequiringUserInput();
        const certs = this.certificationsRequiringUserInput();
        return this.formatTagline(flows, certs);
    }
    formatTagline(flows, certs) {
        return [
            flows.length > 0
                ? `${flows.length} Workflow${flows.length === 1 ? '' : 's'}`
                : undefined,
            certs.length > 0
                ? `${certs.length} Certification${certs.length === 1 ? '' : 's'}`
                : undefined,
        ]
            .filter((i) => i)
            .join(', ');
    }
    requiresUserInput() {
        return (this.flowsRequiringUserInput().length > 0 ||
            this.certificationsRequiringUserInput().length > 0);
    }
    requiresBusinessInput() {
        return (this.flowsRequiringBusinessInput().length > 0 ||
            this.certificationsRequiringBusinessInput().length > 0);
    }
    flowsRequiringUserInput() {
        return this.flows.filter((flow) => flow.requiresUserInput());
    }
    flowsRequiringBusinessInput() {
        return this.flows.filter((flow) => flow.requiresBusinessInput());
    }
    certificationsRequiringBusinessInput() {
        return this.certifications.filter((cert) => cert.requiresBusinessInput());
    }
    certificationsRequiringUserInput() {
        return this.certifications.filter((cert) => cert.requiresUserInput());
    }
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewResponse.prototype, "memberId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], EmployeeOverviewResponse.prototype, "userName", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: EmployeeOverviewFlowResponse }),
    (0, class_validator_1.IsInstance)(EmployeeOverviewFlowResponse, { each: true }),
    (0, tslib_1.__metadata)("design:type", Array)
], EmployeeOverviewResponse.prototype, "flows", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: EmployeeOverviewCertificationResponse }),
    (0, class_validator_1.IsInstance)(EmployeeOverviewCertificationResponse, { each: true }),
    (0, tslib_1.__metadata)("design:type", Array)
], EmployeeOverviewResponse.prototype, "certifications", void 0);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewResponse.prototype, "percentComplete", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewResponse.prototype, "flowsRequiringUserInput", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewResponse.prototype, "flowsRequiringBusinessInput", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewResponse.prototype, "certificationsRequiringBusinessInput", null);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], EmployeeOverviewResponse.prototype, "certificationsRequiringUserInput", null);
exports.EmployeeOverviewResponse = EmployeeOverviewResponse;
class GetPositionsRequest extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], GetPositionsRequest.prototype, "deleted", void 0);
exports.GetPositionsRequest = GetPositionsRequest;
class GetPositionsResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: models_1.Position }),
    (0, class_validator_1.IsInstance)(models_1.Position, { each: true }),
    (0, tslib_1.__metadata)("design:type", Array)
], GetPositionsResponse.prototype, "positions", void 0);
exports.GetPositionsResponse = GetPositionsResponse;
class PositionClient {
    constructor(http, $error) {
        this.http = http;
        this.$error = $error;
        this.getPositions = (0, handler_1.handler)(this, async (args) => this.http
            .request()
            .optionalParams(GetPositionsRequest.create(args).asJSON())
            .to(`/business/positions`)
            .get((res) => GetPositionsResponse.create(res)));
        this.deletePosition = (0, handler_1.handler)(this, async (positionId) => this.http.request().to(`/business/position/${positionId}`).delete());
        /**
         * @example Creating a new position
         * ```ts
         * api.positions().createPosition({
         *  name: 'Senior Butcher',
         * })
         * ```
         *
         * @example Updating an existing position
         * ```ts
         * api.positions().createPosition({
         *  name: 'Senior Butcher',
         *  flowDesignId,
         *  positionId
         * })
         * ```
         */
        this.createOrUpdatePosition = (0, handler_1.handler)(this, async (positionUpdate) => {
            await this.http
                .request()
                .to(`business/my/positions`)
                .bodyJSON(CreateOrUpdatePositionRequest.create(positionUpdate))
                .post();
        });
        this.getEmployeeOverview = (0, handler_1.handler)(this, async () => this.http
            .request()
            .to('employees/overview')
            .get((data) => data.overviews.map((o) => EmployeeOverviewResponse.create(o))));
        this.getPosition = (0, handler_1.handler)(this, async (positionId) => this.http
            .request()
            .to(`positions/${positionId}`)
            .get((data) => models_1.Position.fromJSON(data.position)));
        this.linkFlowDesignToPosition = (0, handler_1.handler)(this, async (options) => {
            await this.http
                .request()
                .to(`/position-flow-designs`)
                .bodyJSON(ChangeFlowDesignLinkedToPositionListing.create({
                ...options,
                state: 'PRESENT',
                performUpdates: options.startFlowForExistingEmployees,
            }))
                .put();
        });
        this.updateFlowDesignLinkedToPosition = (0, handler_1.handler)(this, async (options) => {
            await this.http
                .request()
                .to(`/position-flow-designs`)
                .bodyJSON(ChangeFlowDesignLinkedToPositionListing.create({
                ...options,
                state: 'PRESENT',
                performUpdates: false,
            }))
                .put();
        });
        this.unlinkFlowDesignFromPosition = (0, handler_1.handler)(this, async (options) => {
            await this.http
                .request()
                .to(`/position-flow-designs`)
                .bodyJSON(ChangeFlowDesignLinkedToPositionListing.create({
                ...options,
                state: 'ABSENT',
                performUpdates: options.closeFlowsForDesignFromPosition,
            }))
                .put();
        });
        this.getFlowDesignsLinkedToPosition = (0, handler_1.handler)(this, async (positionId) => this.http
            .request()
            .to(`/position-flow-designs`)
            .param('positionId', positionId)
            .get((data) => (data?.positionFlowDesigns ?? []).map((d) => FlowDesignLinkedToPositionListing.create(d))));
        this.setAccessRequestDefaultPosition = (0, handler_1.handler)(this, async (args) => this.http
            .request()
            .to('/business/access-request/defaults')
            .bodyJSON(SetAccessRequestDefaultPositionRequest.create(args))
            .post());
    }
}
exports.PositionClient = PositionClient;
